import React from 'react';

// New — mirrors the generic (non-CapitaLand) PMS branch's markup/classes for
// visual consistency. Field names (roomNumber, mobile) deliberately match
// backend's authenticateResident(roomNumber, mobile, branchId) verbatim —
// see backend/controllers/portal.controller.js.
const ResidentLoginFields = ({ formData, handleInputChange }) => (
    <div className="animate-fade-in">
        <div className="form-group">
            <label>Room Number</label>
            <div className="input-with-icon">
                <i className="fas fa-door-open"></i>
                <input
                    type="text"
                    name="roomNumber"
                    className="input"
                    placeholder="Room #"
                    required
                    value={formData.roomNumber || ''}
                    onChange={handleInputChange}
                />
            </div>
        </div>
        <div className="form-group">
            <label>Mobile Number</label>
            <div className="input-with-icon">
                <i className="fas fa-mobile-alt"></i>
                <input
                    type="tel"
                    name="mobile"
                    className="input"
                    placeholder="Enter mobile number"
                    required
                    value={formData.mobile || ''}
                    onChange={handleInputChange}
                />
            </div>
        </div>
    </div>
);

export default ResidentLoginFields;
